import { clsx } from 'clsx';
import { FC, MouseEventHandler } from 'react';

import { styled } from '@mui/material/styles';
import ArrowLeftIcon from '@o2/icons/ArrowLeft';
import Box from '@o2/ui/Box';
import IconButton, { IconButtonProps } from '@o2/ui/IconButton';

import { useSubheaderUtilityClasses } from './subheaderClasses';
import { svgIconClasses } from '@mui/material';

interface BacklinkProps extends IconButtonProps {
  onClick?: MouseEventHandler;
}

const BacklinkIconButton = styled(IconButton, {
  name: 'O2Subheader',
  slot: 'Backlink',
})(({ theme }) => ({
  color: theme.palette.text.primary,
  alignSelf: 'flex-start',
  [theme.breakpoints.down('md')]: {
    // hardcoding values here to prevent IconButton changes from impacting this component in the future
    margin: -4,
    marginLeft: -2,
    padding: 0,
    [`& .${svgIconClasses.root}`]: {
      width: 28,
      height: 28,
    },
  },
}));

const BacklinkRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(0.5),
  [theme.breakpoints.up('md')]: {
    justifyContent: 'center',
    marginTop: theme.spacing(1),
  },
}));

const Backlink: FC<BacklinkProps> = ({ classes, ...props }) => {
  const utilityClasses = useSubheaderUtilityClasses(classes);

  return (
    <BacklinkRoot>
      <BacklinkIconButton {...props} className={clsx(utilityClasses.backlink)}>
        <ArrowLeftIcon />
      </BacklinkIconButton>
    </BacklinkRoot>
  );
};

Backlink.displayName = 'Subheader.Backlink';

export default Backlink;
